import { SearchFooterLinks } from '@atlassian/search-dialog';
import React, { useCallback } from 'react';
import { injectIntl } from 'react-intl-next';
import { getTrigger, isNewTab, onMultiSiteAdvancedSearchSelected, useAnalytics } from '../analytics';
import { messages } from '../../messages';
var MAX_PRIMARY_WORKSPACES = 5;
var getActionSubjectIdForProduct = function getActionSubjectIdForProduct(product) {
  return "".concat(product.toLowerCase(), "AdvancedSearchLink");
};
export var MultiWorkspaceAdvancedSearchFooter = function MultiWorkspaceAdvancedSearchFooter(_ref) {
  var workspaces = _ref.workspaces,
    linkComponent = _ref.linkComponent,
    _onClick = _ref.onClick,
    isLoading = _ref.isLoading,
    intl = _ref.intl;
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var links = workspaces.map(function (workspace) {
    return {
      content: workspace.content,
      key: workspace.key,
      href: workspace.advancedSearchUrl
    };
  });
  var label = intl.formatMessage(messages.multi_site_advanced_search_label);
  var dropdownLabel = intl.formatMessage(messages.multi_site_advanced_search_more_dropdown, {
    count: links.length - MAX_PRIMARY_WORKSPACES
  });
  var onAdvancedSearchClicked = useCallback(function (_ref2, e) {
    var key = _ref2.key;
    var workspace = workspaces.filter(function (w) {
      return w.key === key;
    })[0];
    if (!workspace) {
      return;
    }
    fireAnalyticsEvent(onMultiSiteAdvancedSearchSelected({
      trigger: getTrigger(e),
      actionSubjectId: getActionSubjectIdForProduct(workspace.product),
      isLoading: isLoading,
      newTab: isNewTab(e),
      destinationId: key,
      index: workspaces.map(function (w) {
        return w.key;
      }).indexOf(key)
    }));
  }, [fireAnalyticsEvent, isLoading, workspaces]);
  return /*#__PURE__*/React.createElement(SearchFooterLinks, {
    linkComponent: linkComponent,
    onClick: function onClick(link, e) {
      onAdvancedSearchClicked(link, e);
      _onClick && _onClick(link.href, e);
    },
    label: label,
    dropdownTriggerLabel: dropdownLabel,
    links: links,
    maxPrimaryLinks: MAX_PRIMARY_WORKSPACES
  });
};
export default injectIntl(MultiWorkspaceAdvancedSearchFooter);